import { falseFunction } from "./helpers";
import Fetcher from "../fetcher";
import { getValueAtPath } from "../utils";
import {
  DEFAULT_RETRY_CONDITIONS,
  DEFAULT_TIMEOUT,
  isJsonResponse,
  withSharedHeaders
} from "../fetcher/utils";

const CARD_TYPE = Object.create(null);

const $fetch = withSharedHeaders(Fetcher.one
  .limit(3)
  .retry(...DEFAULT_RETRY_CONDITIONS)
  .timeout(DEFAULT_TIMEOUT));

function getCardType(context, card6) {
    const currency = getValueAtPath(context, 'DATA.currency');
    let cache_key = btoa(`${currency}::${card6}`);

    if (CARD_TYPE[cache_key]) return Promise.resolve(CARD_TYPE[cache_key]);

    return $fetch(new URL(`v2/cardbin?cardbin=${card6}&public_key=${getValueAtPath(context, 'DATA.PBFPubKey')}`, process.env.API_BASE_URL))
        .then(response => {
            if (isJsonResponse(response) && response.ok) {
                return response.json()
                    .then(response => {
                        const { card_type } = { ...response.data };
                        Object.defineProperty(CARD_TYPE, cache_key, {
                            value: { 'card_type': card_type }
                        });
                        return CARD_TYPE[cache_key];
                    })
            }
        }).catch(falseFunction)
}

export default getCardType;
